import React from "react";
import { TriggerBuilder } from "@redriver/cinnamon";
import { Menu } from "semantic-ui-react";
import { completeJobItems } from "./actions";

const CompleteSelectedItems = ({
  as: As = Menu.Item,
  jobId,
  selectedIds,
  onSubmitted,
  ...props
}) => (
  <TriggerBuilder
    submitAction={completeJobItems}
    submitParams={{ jobId, selectedIds }}
    onSubmitted={onSubmitted}
    renderTrigger={(fireTrigger) => <As onClick={fireTrigger} {...props} />}
  />
);

export default CompleteSelectedItems;
